var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var Agitavit;
(function (Agitavit) {
    var Controls;
    (function (Controls) {
        var IgDataSourceBase = /** @class */ (function () {
            function IgDataSourceBase() {
                this.settings = {
                    id: "ds",
                    outputResultsName: null,
                    callback: null,
                    callee: null,
                    data: [],
                    dataSource: null,
                    dataBinding: null,
                    dataBound: null,
                    requestType: "GET",
                    type: "unknown",
                    schema: null,
                    primaryKey: null,
                    responseTotalRecCountKey: null,
                    responseDataKey: null,
                    responseDataType: null,
                    responseContentType: null,
                    localSchemaTransform: true,
                    urlParamsEncoding: null,
                    urlParamsEncoded: null,
                    paging: {
                        enabled: false,
                        type: "remote",
                        pageSize: 200,
                        pageSizeUrlKey: null,
                        pageIndexUrlKey: null,
                        pageIndex: 0,
                        appendPage: false
                    },
                    filtering: {
                        type: "remote",
                        caseSensitive: false,
                        applyToAllData: true,
                        customFunc: null,
                        filterExprUrlKey: null,
                        filterLogicUrlKey: "filterLogic",
                        defaultFields: [],
                        expressions: [],
                        exprString: "",
                        customConditions: null
                    },
                    sorting: {
                        defaultDirection: "none",
                        defaultFields: [],
                        applyToAllData: true,
                        customFunc: null,
                        compareFunc: null,
                        customConvertFunc: null,
                        type: "remote",
                        caseSensitive: false,
                        sortUrlKey: null,
                        sortUrlAscValueKey: null,
                        sortUrlDescValueKey: null,
                        expressions: [],
                        exprString: ""
                    },
                    groupby: {
                        defaultCollapseState: false,
                        groupRecordKey: "__gbRecord",
                        groupSummaryRecordKey: "__gbSummaryRecord",
                        summaries: [],
                        summariesPosition: "bottom",
                        pagingMode: "allRecords"
                    },
                    summaries: {
                        type: "remote",
                        summaryExprUrlKey: "summaries",
                        summariesResponseKey: "summaries",
                        summaryExecution: "afterfilteringandpaging",
                        columnSettings: []
                    },
                    fields: [],
                    serializeTransactionLog: true,
                    aggregateTransactions: false,
                    autoCommit: false,
                    updateUrl: null,
                    rowAdded: null,
                    rowUpdated: null,
                    rowInserted: null,
                    rowDeleted: null
                };
            }
            IgDataSourceBase.prototype.init = function (options) {
                debugger;
            };
            IgDataSourceBase.prototype._initSchema = function () {
                debugger;
            };
            IgDataSourceBase.prototype.fields = function (fields) {
                debugger;
            };
            IgDataSourceBase.prototype.analyzeDataSource = function () {
                debugger;
            };
            IgDataSourceBase.prototype.dataView = function () {
                debugger;
            };
            IgDataSourceBase.prototype.data = function () {
                debugger;
            };
            IgDataSourceBase.prototype.transformedData = function (transformedExecution) {
                debugger;
            };
            IgDataSourceBase.prototype.dataSummaries = function () {
                debugger;
            };
            IgDataSourceBase.prototype.schema = function (s, t) {
                debugger;
            };
            IgDataSourceBase.prototype.pagingSettings = function (p) {
                debugger;
            };
            IgDataSourceBase.prototype.filterSettings = function (f) {
                debugger;
            };
            IgDataSourceBase.prototype.sortSettings = function (s) {
                debugger;
            };
            IgDataSourceBase.prototype.summariesSettings = function (s) {
                debugger;
            };
            IgDataSourceBase.prototype.dataSource = function (ds) {
                debugger;
            };
            IgDataSourceBase.prototype.type = function (t) {
                debugger;
            };
            IgDataSourceBase.prototype.findRecordByKey = function (key, ds, objPath) {
                debugger;
            };
            IgDataSourceBase.prototype.removeRecordByKey = function (key, origDs) {
                debugger;
            };
            IgDataSourceBase.prototype.removeRecordByIndex = function (index, origDs) {
                debugger;
            };
            IgDataSourceBase.prototype.setCellValue = function (rowId, colId, val, autoCommit) {
                debugger;
            };
            IgDataSourceBase.prototype.updateRow = function (rowId, rowObject, autoCommit) {
                debugger;
            };
            IgDataSourceBase.prototype.addRow = function (rowId, rowObject, autoCommit) {
                debugger;
            };
            IgDataSourceBase.prototype.insertRow = function (rowId, rowObject, rowIndex, autoCommit, parentRowId) {
                debugger;
            };
            IgDataSourceBase.prototype.deleteRow = function (rowId, autoCommit) {
                debugger;
            };
            IgDataSourceBase.prototype.addNode = function (data) {
                debugger;
            };
            IgDataSourceBase.prototype.removeNode = function (data) {
                debugger;
            };
            IgDataSourceBase.prototype.getDetachedRecord = function (t) {
                debugger;
            };
            IgDataSourceBase.prototype.commit = function (id) {
                debugger;
            };
            IgDataSourceBase.prototype.rollback = function (id) {
                debugger;
            };
            IgDataSourceBase.prototype.pendingTransactions = function () {
                debugger;
            };
            IgDataSourceBase.prototype.allTransactions = function () {
                debugger;
            };
            IgDataSourceBase.prototype._createCellTransaction = function (rowId, colId, val) {
                debugger;
            };
            IgDataSourceBase.prototype._createRowTransaction = function (rowId, rowObject) {
                debugger;
            };
            IgDataSourceBase.prototype._createNewRowTransaction = function (rowId, rowObject) {
                debugger;
            };
            IgDataSourceBase.prototype._createInsertRowTransaction = function (rowId, rowObject, rowIndex) {
                debugger;
            };
            IgDataSourceBase.prototype._createDeleteRowTransaction = function (rowId) {
                debugger;
            };
            IgDataSourceBase.prototype._createAddNodeTransaction = function (data) {
                debugger;
            };
            IgDataSourceBase.prototype._createRemoveNodeTransaction = function (data) {
                debugger;
            };
            IgDataSourceBase.prototype._addTransaction = function (t) {
                debugger;
            };
            IgDataSourceBase.prototype._syncGlobalTransaction = function (t) {
                debugger;
            };
            IgDataSourceBase.prototype._serializeDate = function (date) {
                debugger;
            };
            IgDataSourceBase.prototype._removeTransactionByTransactionId = function (tid, removeFromAll) {
                debugger;
            };
            IgDataSourceBase.prototype._removeTransactionsByRecordId = function (id) {
                debugger;
            };
            IgDataSourceBase.prototype._addRow = function (row, index, origDs) {
                debugger;
            };
            IgDataSourceBase.prototype._updateRecOnCommit = function (t, records) {
                debugger;
            };
            IgDataSourceBase.prototype._commitTransaction = function (t) {
                debugger;
            };
            IgDataSourceBase.prototype._rollbackTransaction = function (t) {
                debugger;
            };
            IgDataSourceBase.prototype._commitTransactionsByRowId = function (id) {
                debugger;
            };
            IgDataSourceBase.prototype._rollbackTransactionsByRowId = function (id) {
                debugger;
            };
            IgDataSourceBase.prototype._addOnlyUniqueToCollection = function (collection, item) {
                debugger;
            };
            IgDataSourceBase.prototype.transactionsAsString = function () {
                debugger;
            };
            IgDataSourceBase.prototype._generateTransactionId = function () {
                debugger;
            };
            IgDataSourceBase.prototype._lookupPkIndex = function () {
                debugger;
            };
            IgDataSourceBase.prototype.saveChanges = function (success, error) {
                debugger;
            };
            IgDataSourceBase.prototype._saveChangesSuccess = function (data, textStatus, jqXHR) {
                debugger;
            };
            IgDataSourceBase.prototype._saveChangesError = function (jqXHR, textStatus, errorThrown) {
                debugger;
            };
            IgDataSourceBase.prototype._addChangesSuccessHandler = function (functionDelegate) {
                debugger;
            };
            IgDataSourceBase.prototype._removeChangesSuccessHandler = function (functionDelegate) {
                debugger;
            };
            IgDataSourceBase.prototype._addChangesErrorHandler = function (functionDelegate) {
                debugger;
            };
            IgDataSourceBase.prototype._removeChangesErrorHandler = function (functionDelegate) {
                debugger;
            };
            IgDataSourceBase.prototype.dataBind = function (callback, callee) {
                debugger;
            };
            IgDataSourceBase.prototype.getCellValue = function (fieldName, record) {
                debugger;
            };
            IgDataSourceBase.prototype._getFieldTypeFromSchema = function (fieldName) {
                debugger;
            };
            IgDataSourceBase.prototype._internalDataBound = function (callDatabound) {
                debugger;
            };
            IgDataSourceBase.prototype.summariesResponse = function (key, dsObj) {
                debugger;
            };
            IgDataSourceBase.prototype._applySchema = function (forceApply) {
                debugger;
            };
            IgDataSourceBase.prototype._populateTransformedData = function (data) {
                debugger;
            };
            IgDataSourceBase.prototype._invokeCallback = function (callee, callback) {
                debugger;
            };
            IgDataSourceBase.prototype._remoteData = function (callback, callee) {
                debugger;
            };
            IgDataSourceBase.prototype._dataFilter = function (data, type) {
                debugger;
            };
            IgDataSourceBase.prototype._successCallback = function (data) {
                debugger;
            };
            IgDataSourceBase.prototype._errorCallback = function (req, status, error) {
                debugger;
            };
            IgDataSourceBase.prototype._completeCallback = function () {
                debugger;
            };
            IgDataSourceBase.prototype._processRequest = function (options) {
                debugger;
            };
            IgDataSourceBase.prototype._jsonpFilter = function (data) {
                debugger;
            };
            IgDataSourceBase.prototype._processJsonResponse = function (data, context) {
                debugger;
            };
            IgDataSourceBase.prototype._processXmlResponse = function (data, isParsed, context) {
                debugger;
            };
            IgDataSourceBase.prototype._xmlToArray = function (data) {
                debugger;
            };
            IgDataSourceBase.prototype._encodeUrl = function () {
                debugger;
            };
            IgDataSourceBase.prototype._encodePkParams = function (params) {
                debugger;
            };
            IgDataSourceBase.prototype._encodeSelectParams = function (params) {
                debugger;
            };
            IgDataSourceBase.prototype._encodePagingParams = function (params) {
                debugger;
            };
            IgDataSourceBase.prototype._encodeSortingParams = function (params) {
                debugger;
            };
            IgDataSourceBase.prototype._encodeFilteringParams = function (params) {
                debugger;
            };
            IgDataSourceBase.prototype._encodeSummariesParams = function (params) {
                debugger;
            };
            IgDataSourceBase.prototype.filteredData = function () {
                debugger;
            };
            IgDataSourceBase.prototype._page = function (keepRecords) {
                debugger;
            };
            IgDataSourceBase.prototype._getPageStartEndIndex = function (data) {
                debugger;
            };
            IgDataSourceBase.prototype._generateGroupByPageDataForAllRecords = function () {
                debugger;
            };
            IgDataSourceBase.prototype._generateGroupByPageDataForDataRecordsOnly = function (data) {
                debugger;
            };
            IgDataSourceBase.prototype._generateGroupByPageData = function (data) {
                debugger;
            };
            IgDataSourceBase.prototype._generatePageData = function (data, count) {
                debugger;
            };
            IgDataSourceBase.prototype._compareValues = function (x, y) {
                debugger;
            };
            IgDataSourceBase.prototype._sortByFieldExpression = function (data, f, direction, convertf) {
                debugger;
            };
            IgDataSourceBase.prototype._sortDataRecursive = function (data, fields, fieldIndex, defSortDir, convertFunc) {
                debugger;
            };
            IgDataSourceBase.prototype.sort = function (fields, direction) {
                debugger;
            };
            IgDataSourceBase.prototype.clearLocalSorting = function () {
                debugger;
            };
            IgDataSourceBase.prototype._parseSortExpressions = function (s) {
                debugger;
            };
            IgDataSourceBase.prototype._splitFilterExpression = function (search) {
                debugger;
            };
            IgDataSourceBase.prototype._filterAllFields = function (val, data, fields) {
                debugger;
            };
            IgDataSourceBase.prototype._findMatchByFields = function (searchTokens, rec, fields, formattedRecord) {
                debugger;
            };
            IgDataSourceBase.prototype._getFieldsWithFormatter = function () {
                debugger;
            };
            IgDataSourceBase.prototype._generateFormattedRecords = function (data) {
                debugger;
            };
            IgDataSourceBase.prototype.filterByText = function (expression, fields) {
                debugger;
            };
            IgDataSourceBase.prototype.filter = function (fieldExpressions, boolLogic, keepFilterState, fieldExpressionsOnStrings) {
                debugger;
            };
            IgDataSourceBase.prototype.clearLocalFilter = function () {
                debugger;
            };
            IgDataSourceBase.prototype._parseFilterExprString = function (expr) {
                debugger;
            };
            IgDataSourceBase.prototype._isFilteringExprNotReq = function (cond) {
                debugger;
            };
            IgDataSourceBase.prototype._findMatch = function (val, expr, t, ignoreCase, cond, preciseDateFormat, colKey, rec) {
                debugger;
            };
            IgDataSourceBase.prototype._findStringMatch = function (val, expr, ignoreCase, cond) {
                debugger;
            };
            IgDataSourceBase.prototype._findRegExpMatch = function (val, expr, str) {
                debugger;
            };
            IgDataSourceBase.prototype._findNumericMatch = function (val, expr, cond) {
                debugger;
            };
            IgDataSourceBase.prototype._findBoolMatch = function (val, cond) {
                debugger;
            };
            IgDataSourceBase.prototype._getDateParts = function (date) {
                debugger;
            };
            IgDataSourceBase.prototype._findDateMatch = function (val, expr, cond, preciseDateFormat) {
                debugger;
            };
            IgDataSourceBase.prototype.totalRecordsCount = function (count, key, dsObj, context) {
                debugger;
            };
            IgDataSourceBase.prototype.hasTotalRecordsCount = function (hasCount) {
                debugger;
            };
            IgDataSourceBase.prototype.metadata = function (key) {
                debugger;
            };
            IgDataSourceBase.prototype.totalLocalRecordsCount = function () {
                debugger;
            };
            IgDataSourceBase.prototype.pageCount = function () {
                debugger;
            };
            IgDataSourceBase.prototype.pageIndex = function (index) {
                debugger;
            };
            IgDataSourceBase.prototype.persistedPageIndex = function (value) {
                debugger;
            };
            IgDataSourceBase.prototype.prevPage = function () {
                debugger;
            };
            IgDataSourceBase.prototype.nextPage = function () {
                debugger;
            };
            IgDataSourceBase.prototype.pageSize = function (s) {
                debugger;
            };
            IgDataSourceBase.prototype.pageSizeDirty = function (dirty) {
                debugger;
            };
            IgDataSourceBase.prototype.recordsForPage = function (p) {
                debugger;
            };
            IgDataSourceBase.prototype.tableToObject = function (tableDOM) {
                debugger;
            };
            IgDataSourceBase.prototype._validateTable = function (obj) {
                debugger;
            };
            IgDataSourceBase.prototype.stringToJSONObject = function (s) {
                debugger;
            };
            IgDataSourceBase.prototype.stringToXmlObject = function (s) {
                debugger;
            };
            IgDataSourceBase.prototype.groupByData = function () {
                debugger;
            };
            IgDataSourceBase.prototype.visibleGroupByData = function () {
                debugger;
            };
            IgDataSourceBase.prototype.groupByDataView = function () {
                debugger;
            };
            IgDataSourceBase.prototype._groupedRecordsByExpr = function (data, startInd, gbExpr, gbRes) {
                debugger;
            };
            IgDataSourceBase.prototype.toggleGroupByRecord = function (id, collapsed) {
                debugger;
            };
            IgDataSourceBase.prototype.isGroupByRecordCollapsed = function (gbRec) {
                debugger;
            };
            IgDataSourceBase.prototype._resetGroupByCollapseStates = function () {
                debugger;
            };
            IgDataSourceBase.prototype._processGroupsRecursive = function (data, gbExprs, gbInd, parentCollapsed, parentId) {
                debugger;
            };
            IgDataSourceBase.prototype._calculateGroupBySummaries = function (gbRec, parentCollapsed) {
                debugger;
            };
            IgDataSourceBase.prototype._addSummaryRecToArray = function (gbSummaryRec, gbRec, array) {
                debugger;
            };
            IgDataSourceBase.prototype._generateGroupByData = function (data, gbExprs, collapsedRows) {
                debugger;
            };
            IgDataSourceBase.prototype._clearGroupByData = function () {
                debugger;
            };
            IgDataSourceBase.prototype.isGroupByApplied = function (exprs) {
                debugger;
            };
            IgDataSourceBase.prototype._findSortingExpressionsForLayout = function (expressions, layout) {
                debugger;
            };
            return IgDataSourceBase;
        }());
        Controls.IgDataSourceBase = IgDataSourceBase;
        var IgRemoteDataSource = /** @class */ (function (_super) {
            __extends(IgRemoteDataSource, _super);
            function IgRemoteDataSource(columns, initialData, inlineTemplateRowData, triggerReload, clearSelection, endEdit, startInlineEdit, setPostBackData, collapseGroupBy, addNewRowsToEnd) {
                var _this = _super.call(this) || this;
                _this._columnInfo = {};
                _this._initialDataReady = false;
                _this._changeset = {};
                _this._addCount = 0;
                _this._columns = columns;
                _this._data = initialData;
                _this._initialDataReady = initialData && initialData.Data ? true : false;
                _this._inlineTemplateRowData = inlineTemplateRowData;
                _this._triggerReload = triggerReload;
                _this._clearSelection = clearSelection;
                _this._endEdit = endEdit;
                _this._startInlineEdit = startInlineEdit;
                _this._setPostBackData = setPostBackData;
                _this.collapseGroupBy = collapseGroupBy;
                _this._addNewRowsToEnd = addNewRowsToEnd;
                // init column information
                columns.forEach(function (col) {
                    var editor = col.Editor ? eval(col.Editor) : null;
                    _this._columnInfo[col.BaseName] = {
                        mapper: editor && editor.tableDisplayMapper ? editor.tableDisplayMapper : null,
                        dataType: editor && editor.tableDisplayJsType ? editor.tableDisplayJsType : (col.JsType || "string")
                    };
                });
                // re-add new rows
                if (_this._initialDataReady) {
                    _this._data.Data
                        .filter(function (row) { return row._001_IsNew; })
                        .reverse()
                        .forEach(function (row) {
                        _this.addInlineRow(row);
                        _this._data.Data.splice(_this._data.Data.indexOf(row), 1);
                    });
                }
                return _this;
            }
            IgRemoteDataSource.prototype.resetPaging = function () {
                this.settings.paging.pageIndex = 0;
            };
            IgRemoteDataSource.prototype.filterNewRows = function (rows) {
                return rows;
            };
            IgRemoteDataSource.prototype.setData = function (data, skipCallback, doNotClearSelection) {
                var _a;
                var _this = this;
                // clear selection
                if (!doNotClearSelection) {
                    this._clearSelection();
                }
                // clear existing data
                this._data = data;
                this._groupedData = null;
                this._groupedDataView = null;
                this._groupedDataNonCollapsedView = null;
                this._groupedRowsMapping = null;
                var existingNewRows = {};
                var _loop_1 = function (i) {
                    var cs = this_1._changeset[this_1._data.Data[i]._001_RecordId];
                    // apply updated values
                    if (cs) {
                        Object.keys(cs).forEach(function (key) {
                            _this._data.Data[i][key] = cs[key];
                        });
                        existingNewRows[this_1._data.Data[i]._001_RecordId] = true;
                    }
                };
                var this_1 = this;
                // apply changesets
                for (var i = 0; i < this._data.Data.length; i++) {
                    _loop_1(i);
                }
                // add new rows
                var newRows = [];
                Object.keys(this._changeset).forEach(function (key) {
                    if (key.startsWith("_001_NewRecord_") && !existingNewRows[_this._changeset[key]._001_RecordId]) {
                        var newRow_1 = {};
                        var changeset_1 = _this._changeset[key];
                        Object.keys(changeset_1).forEach(function (column) { return newRow_1[column] = changeset_1[column]; });
                        if (_this._addNewRowsToEnd) {
                            newRows.push(newRow_1);
                        }
                        else {
                            newRows.splice(0, 0, newRow_1);
                        }
                    }
                }, this);
                newRows = this.filterNewRows(newRows);
                if (newRows.length > 0) {
                    if (this._addNewRowsToEnd) {
                        newRows.forEach(function (row) { return _this._data.Data.push(row); });
                    }
                    else {
                        (_a = this._data.Data).splice.apply(_a, __spreadArrays([0, 0], newRows));
                    }
                }
                // data is ready
                if (!skipCallback) {
                    this._invokeCallback();
                }
            };
            IgRemoteDataSource.prototype.type = function (t) {
                if (!t) {
                    return "remoteUrl";
                }
                throw new Error("type is read-only.");
            };
            IgRemoteDataSource.prototype._initSchema = function () { };
            IgRemoteDataSource.prototype.schema = function (s, t) {
                if (!s && !t) {
                    return null;
                }
                throw new Error("schema is read-only.");
            };
            IgRemoteDataSource.prototype.data = function () {
                return this._data ? this._data.Data : [];
            };
            IgRemoteDataSource.prototype.dataView = function () {
                if (this._groupedDataView) {
                    return this._groupedDataView;
                }
                return this.data();
            };
            IgRemoteDataSource.prototype.dataBind = function (callback, callee) {
                // return data if it's ready, otherwise (re)load data
                if (this._initialDataReady) {
                    this._invokeCallback(callee, callback);
                    this._initialDataReady = false;
                }
                else {
                    this._triggerReload();
                }
            };
            /**
             * Gets required data for form element reload.
             */
            IgRemoteDataSource.prototype.getFormElementDataRequest = function () {
                var formats = this._columns.map(function (c) {
                    return {
                        columnName: c.BaseName,
                        format: c.Editor ? c.Editor : c.Format === "dateTime" ? "Agitavit.Controls.AgDateTimeControl" : c.Format === "date" ? "Agitavit.Controls.AgDateControl" : c.JsType === "bool" ? "Agitavit.Controls.AgBooleanControl" : c.JsType === "number" ? "Agitavit.Controls.AgNumericControl" : null,
                        dataType: c.DataType,
                    };
                });
                return {
                    Filters: Controls.Utilities.convertIgFilterToJsonExpression(this.settings.filtering.expressions, formats),
                    PageSize: this.settings.paging.pageSize,
                    PageIndex: this.settings.paging.pageIndex,
                    OrderByColumns: this.settings.sorting.expressions.map(function (expr) { return ({
                        BaseName: expr.fieldName,
                        IsDescending: expr.dir === "desc",
                        IsGroupBy: !!expr.isGroupBy
                    }); })
                };
            };
            IgRemoteDataSource.prototype._invokeCallback = function (callee, callback) {
                if (!callback) {
                    callback = this.settings.callback;
                }
                if (!callee) {
                    callee = this.settings.callee;
                }
                if (callback) {
                    if (callee) {
                        callback.apply(callee, [true, "", this]);
                    }
                    else {
                        callback(true, "", this);
                    }
                }
            };
            IgRemoteDataSource.prototype.getCellValue = function (fieldName, record) {
                var mapper = this._columnInfo[fieldName].mapper;
                // try getting cell value via mapper (if defined)
                var value = record.__gbRecord
                    ? (record.recs.length ? this.getCellValue(fieldName, record.recs[0]) : null)
                    : (mapper ? mapper(fieldName, record, this._inlineTemplateRowData) : record[fieldName]);
                if (typeof value === "number" && this._columnInfo[fieldName].dataType === "bool") {
                    if (value == 1) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                if (typeof value === "string" && this._columnInfo[fieldName].dataType === "date") {
                    return (value.startsWith("/Date(")
                        ? new Date(parseInt(value.substr(6)))
                        : new Date(value));
                }
                return value;
            };
            IgRemoteDataSource.prototype._getFieldTypeFromSchema = function (fieldName) {
                return this._columnInfo[fieldName].dataType;
            };
            IgRemoteDataSource.prototype.isGroupByApplied = function (exprs) {
                return this.settings.sorting.expressions.length > 0 && this.settings.sorting.expressions[0].isGroupBy;
            };
            IgRemoteDataSource.prototype.pageSizeDirty = function (dirty) {
                if (dirty == null || dirty == undefined) {
                    return false;
                }
                throw new Error("dirty is read-only.");
            };
            IgRemoteDataSource.prototype.totalRecordsCount = function (count, key, dsObj, context) {
                if (!count) {
                    return this._data && this._data.TotalRecords ? this._data.TotalRecords : 0;
                }
                throw new Error("totalRecordsCount is read-only.");
            };
            IgRemoteDataSource.prototype.totalLocalRecordsCount = function () {
                return this._data && this._data.Data ? this._data.Data.length : 0;
            };
            IgRemoteDataSource.prototype.pageSize = function (s) {
                if (!s) {
                    return this.settings.paging.pageSize;
                }
                throw new Error("pageSize is readonly.");
            };
            IgRemoteDataSource.prototype.pageCount = function () {
                return this._data && this._data.TotalRecords
                    ? Math.ceil(this._data.TotalRecords / this.settings.paging.pageSize)
                    : 1;
            };
            IgRemoteDataSource.prototype.groupByDataView = function () {
                // check if we have cached instance of grouped data view
                if (this._groupedDataNonCollapsedView) {
                    return this._groupedDataNonCollapsedView;
                }
                // figure out columns to group by
                var groupedColumns = [];
                for (var i = 0; i < this.settings.sorting.expressions.length; i++) {
                    if (this.settings.sorting.expressions[i].isGroupBy) {
                        groupedColumns.push(this.settings.sorting.expressions[i].fieldName);
                    }
                    else {
                        break;
                    }
                }
                // calculate grouped data view only if we're grouping by any column
                this._groupedRowsMapping = {};
                if (groupedColumns.length === 0) {
                    this._groupedData = this._data;
                    this._groupedDataView = this._data;
                    this._groupedDataNonCollapsedView = this._data;
                }
                else {
                    this.settings.groupby.defaultCollapseState = this.collapseGroupBy === true;
                    this._groupedData = this._groupByDataRec(groupedColumns, this._data.Data, 0, "");
                    this._groupedDataView = [];
                    this._groupedDataNonCollapsedView = [];
                    this._groupedDataView = this._createGroupByDataViewRec(this._groupedData, this._groupedDataView, this._groupedDataNonCollapsedView, false);
                }
                return this._groupedDataNonCollapsedView;
            };
            IgRemoteDataSource.prototype._getGroupByLength = function (key, result) {
                if (result.length > 0) {
                    return result[0].__gbRecord ? this._getGroupByLength(key, result[0].recs) : result[0]["_001__" + key + "__GroupByCount"];
                }
                return 0;
            };
            IgRemoteDataSource.prototype._getComparableValue = function (val) {
                if (val instanceof Date) {
                    return val.getTime();
                }
                return val;
            };
            /**
             * Creates tree like structure of grouped columns.
             * @param cols - Columns to group by.
             * @param data - Data to be grouped by.
             * @param level - Current grup by level.
             * @param parentId - Parent row (group by) id.
             */
            IgRemoteDataSource.prototype._groupByDataRec = function (cols, data, level, parentId) {
                if (data.length === 0) {
                    return [];
                }
                var col = cols.shift();
                var current = this.getCellValue(col, data[0]);
                var i = 0;
                var result = [];
                while (i < data.length) {
                    var currentResult = [];
                    var currentId = parentId + col + ":" + current + "hc";
                    while (i < data.length && this._getComparableValue(this.getCellValue(col, data[i])) === this._getComparableValue(current)) {
                        currentResult.push(data[i]);
                        i++;
                    }
                    if (cols.length > 0) {
                        currentResult = this._groupByDataRec(cols.slice(0), currentResult, level + 1, currentId);
                    }
                    var dbRecords = this._getGroupByLength(col, currentResult);
                    currentResult.length = dbRecords;
                    var gbRecord = {
                        __gbRecord: true,
                        fieldName: col,
                        val: current,
                        id: currentId,
                        collapsed: this.settings.groupby.defaultCollapseState,
                        level: level,
                        recs: currentResult,
                        len: dbRecords
                    };
                    result.push(gbRecord);
                    this._groupedRowsMapping[currentId] = gbRecord;
                    if (i < data.length) {
                        current = this.getCellValue(col, data[i]);
                    }
                }
                return result;
            };
            IgRemoteDataSource.prototype._createGroupByDataViewRec = function (groupByData, resultAll, resultNonCollapsed, collapsed) {
                for (var i = 0; i < groupByData.length; i++) {
                    var row = groupByData[i];
                    if (!row) {
                        break;
                    }
                    resultAll.push(row);
                    if (!collapsed) {
                        resultNonCollapsed.push(row);
                    }
                    if (row.__gbRecord) {
                        this._createGroupByDataViewRec(row.recs, resultAll, resultNonCollapsed, row.collapsed || collapsed);
                    }
                }
            };
            IgRemoteDataSource.prototype.metadata = function (key) {
                return null;
            };
            IgRemoteDataSource.prototype.toggleGroupByRecord = function (id, collapsed) {
                this._groupedRowsMapping[id].collapsed = collapsed;
                this._groupedDataView = [];
                this._groupedDataNonCollapsedView = [];
                this._groupedDataView = this._createGroupByDataViewRec(this._groupedData, this._groupedDataView, this._groupedDataNonCollapsedView, false);
            };
            IgRemoteDataSource.prototype.hasTotalRecordsCount = function (hasCount) {
                if (hasCount == null || hasCount == undefined) {
                    return true;
                }
                throw new Error("hasCount is read-only.");
            };
            IgRemoteDataSource.prototype._isFilteringExprNotReq = function (cond) {
                return cond === "false" || cond === "true" ||
                    cond === "today" || cond === "yesterday" ||
                    cond === "thisMonth" || cond === "lastMonth" ||
                    cond === "nextMonth" || cond === "thisYear" ||
                    cond === "lastYear" || cond === "nextYear" ||
                    cond === "null" || cond === "notNull" ||
                    cond === "empty" || cond === "notEmpty";
            };
            IgRemoteDataSource.prototype.prevPage = function () {
                this.settings.paging.pageIndex--;
                this._triggerReload();
            };
            IgRemoteDataSource.prototype.nextPage = function () {
                this.settings.paging.pageIndex++;
                this._triggerReload();
            };
            IgRemoteDataSource.prototype.pageIndex = function (index) {
                if (index == null || index == undefined) {
                    return this.settings.paging.pageIndex;
                }
                this.settings.paging.pageIndex = index;
                this._triggerReload();
                return index;
            };
            IgRemoteDataSource.prototype._addChangesSuccessHandler = function (functionDelegate) { };
            IgRemoteDataSource.prototype.pendingTransactions = function () {
                return [];
            };
            IgRemoteDataSource.prototype.findRecordByKey = function (key, ds, objPath) {
                var _this = this;
                return this._data.Data.find(function (v) { return v[_this.settings.primaryKey] === key; });
            };
            IgRemoteDataSource.prototype.updateRow = function (rowId, rowObject, autoCommit, skipCallback) {
                var cs = this._changeset[rowId] || __assign({}, this.findRecordByKey(rowId)) || {};
                // store new (changed) values
                Object.keys(rowObject).forEach(function (key) { return cs[key] = rowObject[key]; });
                this._changeset[rowId] = cs;
                this._setPostBackData(this._changeset);
                // refresh grid
                this.setData(this._data, skipCallback);
                return {
                    type: "row",
                    row: rowObject,
                    rowId: rowId,
                    tid: 1000
                };
            };
            IgRemoteDataSource.prototype.initNewRow = function (row) {
                return row;
            };
            IgRemoteDataSource.prototype.addInlineRow = function (newRowData, addToEnd, skipCallback, doNotStartEdit) {
                var _this = this;
                // try ending current edit
                if (!this._endEdit()) {
                    return;
                }
                // create empty record
                var csValues = {};
                this._columns.forEach(function (col) {
                    csValues[col.BaseName] = newRowData && newRowData[col.BaseName] !== undefined
                        ? newRowData[col.BaseName]
                        : ((_this._inlineTemplateRowData[col.BaseName] !== undefined ? _this._inlineTemplateRowData[col.BaseName].Value : null) || null);
                });
                csValues._001_RecordId = "_001_NewRecord_" + this._addCount++;
                csValues = this.initNewRow(csValues);
                this._changeset[csValues._001_RecordId] = csValues;
                this._setPostBackData(this._changeset);
                // add to end if requested (otherwise it"s added by setData to location set on control level)
                if (addToEnd) {
                    this._data.Data.push(__assign({}, csValues));
                }
                // force re-render
                this.setData(this._data, skipCallback);
                // set focus
                if (!doNotStartEdit) {
                    this._startInlineEdit(csValues._001_RecordId);
                }
            };
            /**
             * Removes from changeset only (doesn't refresh the view!).
             * @param rowId
             */
            IgRemoteDataSource.prototype.removeFromChangeset = function (rowId) {
                delete this._changeset[rowId];
                this._setPostBackData(this._changeset);
            };
            IgRemoteDataSource.prototype.clearPendingChanges = function () {
                this._changeset = {};
                this._setPostBackData(this._changeset);
            };
            return IgRemoteDataSource;
        }(IgDataSourceBase));
        Controls.IgRemoteDataSource = IgRemoteDataSource;
    })(Controls = Agitavit.Controls || (Agitavit.Controls = {}));
})(Agitavit || (Agitavit = {}));
//# sourceMappingURL=IgRemoteDataSource.js.map